<template>
  <span>
    <svg
      width="100px"
      height="100px"
      viewBox="-50 -50 100 100">
      <polyline
        ref="line"
        id="load-anim" />
    </svg>
  </span>
</template>

<script>
  import { TweenMax, Power3 } from 'gsap'
  import EventBus from './../event-bus'

  const SIDE = 40
  const H = SIDE * (Math.sqrt(3) / 2)
  const POINTS = [
    {x: -SIDE / 2, y: H / 2},
    {x: 0, y: -H / 2},
    {x: SIDE / 2, y: H / 2}
  ]
  POINTS.push(POINTS[0])

  export default {
    mounted () {
      EventBus.$on('LoaderAnim.ACTIVATE', this.onActivate)
      this.onActivate()
    },
    beforeDestroy () {
      EventBus.$off('LoaderAnim.ACTIVATE', this.onActivate)
    },
    methods: {
      resetStyle () {
        this.$refs.line.setAttribute('class', '')
        this.$refs.line.style.transform = 'rotate(0deg)'
      },
      onActivate () {
        this.$el.style.display = 'block'
        this.resetStyle()
        this.animStart(0)
      },
      animStart (rotation) {
        let a = []
        let pt = {
          x: POINTS[0].x,
          y: POINTS[0].y
        }
        this.animTo(a, pt, 1, rotation)
      },
      animTo (a, pt, index, rotation) {
        if (index < POINTS.length) {
          a.push(pt.x, pt.y)
          TweenMax.to(pt, 0.3, {x: POINTS[index].x, y: POINTS[index].y, ease: Power3.easeOut, onUpdate: this.render, onUpdateParams: [a, pt], onComplete: this.animTo, onCompleteParams: [a, pt, index + 1, rotation]})
        } else {
          this.animEnd(rotation)
        }
      },
      animEnd (rotation) {
        let _clearAnim = false
        let e = {
          clearAnim () {
            _clearAnim = true
          }
        }
        EventBus.dispatchEvent('LoaderAnim.ANIM_END', e)
        if (_clearAnim) {
          this.$refs.line.setAttribute('class', 'fade')
          this.$refs.line.style.transform = 'scale(1.5) rotate(' + rotation + 'deg)'
          let vm = this
          setTimeout(function () {
            vm.$el.style.display = 'none'
          }, 500)
        } else {
          rotation += 90
          this.$refs.line.style.transform = 'rotate(' + rotation + 'deg)'
          this.animStart(rotation)
        }
      },
      render (a, pt) {
        a = a.slice()
        a.push(pt.x, pt.y)
        this.$refs.line.setAttribute('points', a.join(' '))
      }
    }
  }
</script>

<style scoped>
    span {
        position: fixed;
        display: none;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 40;
    }
    svg {
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -50px 0 0 -50px;
    }
    polyline {
        stroke:#FFFFFF;
        fill:none;
        stroke-width:1px;
        transform: rotate(0deg);
        transition: transform 0.5s ease-in-out, opacity 0.5s cubic-bezier(0.770, 0.000, 0.175, 1.000);
    }
    polyline.fade {
      opacity: 0;
    }
</style>
